module.exports = __webpack_public_path__ + "img/whatsapp.59e71739.svg";